import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { UpdateOrganizationAccountManagerRequest } from '../../types';
import { useUpdateOrgAccountManager } from './useOrganizationMutations';

type MutationParams = {
  data: UpdateOrganizationAccountManagerRequest;
  id: string | number;
};

export const usePatchOrgAccountManagerDocumentFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => {
  const { mutateAsync } = useUpdateOrgAccountManager();
  return useMutation<void, AxiosError, MutationParams>({
    mutationFn: async ({ data, id }) => {
      await mutateAsync({ id: String(id), account_manager: data.account_manager });
    },
    ...options,
  });
};
